module.exports = "/_next/static/images/logo_main-light-alt-fe4488ec56cacc42dcc64da783fe90b7.png";